export function isDeploymentRecoveryEnabled() {
  return process.env.NODE_ENV !== "development";
}
